import { render, staticRenderFns } from "./SortableItem.vue?vue&type=template&id=d9725830&scoped=true&"
import script from "./SortableItem.vue?vue&type=script&lang=js&"
export * from "./SortableItem.vue?vue&type=script&lang=js&"
import style0 from "./SortableItem.vue?vue&type=style&index=0&id=d9725830&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9725830",
  null
  
)

export default component.exports